import ztComponent from './ztHeaderBar.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
